module.exports = function() {
  return new Worker(__webpack_public_path__ + "9ecfe1dcf56cbd3a48f8.worker.js");
};